import { useState } from 'react';

export const useAutoCompleteState = (isTransfer = false) => {
  const [value, setValue] = useState();

  const handleChange = (_, newValue) => {
    setValue(isTransfer ? newValue.title : newValue.id);
  };

  return [value, handleChange];
};
